import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Router from 'next/router';
import withSizes from 'react-sizes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeModal } from '../../redux/actions';
import User from "../User";
import UserNavigation from '../UserNavigation';
import Logotype from "../Logotype";

import { NavigationOverlay, NavigationLogo, NavigationContainer, NavigationList, NavigationItem } from "./styles";

const mapStateToProps = state => ({
  user: state.user.userData,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleModalClose: closeModal,
}, dispatch);

const mapSizesToProps = ({ width }) => ({
  notDesktop: width < 1024,
  isTablet: width > 500 && width < 1024,
});

@connect(mapStateToProps, mapDispatchToProps)
@withSizes(mapSizesToProps)
class Navigation extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isInnerPage: PropTypes.bool,
    isTablet: PropTypes.bool,
    notDesktop: PropTypes.bool,
    user: PropTypes.instanceOf(Object),
    handleModalClose: PropTypes.func,
  };

  componentDidMount() {
    const { handleRouteChange } = this;

    Router.events.on('routeChangeComplete', handleRouteChange);
  }

  componentWillUnmount() {
    const { handleRouteChange } = this;

    Router.events.off('routeChangeComplete', handleRouteChange);
  }

  handleRouteChange = url => {
    const { handleModalClose } = this.props;

    if (url.startsWith('/my-')) {
      handleModalClose();
    }
  };

  render() {
    const { isOpen, isInnerPage, isTablet, notDesktop, user } = this.props;

    return (
      <Fragment>
        {isTablet && isOpen && <NavigationOverlay />}
        <NavigationContainer isOpen={isOpen}>
          {isTablet && <NavigationLogo><Logotype innerPage={isInnerPage} /></NavigationLogo>}
          <User isInnerPage={isInnerPage} isOpen={isOpen} />
          {user && notDesktop && isOpen && <UserNavigation isInNavigation />}
          <NavigationList>
            <NavigationItem>
              <a href="https://www.blog.dayaxe.com/contact-us" target="_blank" rel="noopener noreferrer">Help</a>
            </NavigationItem>
            <NavigationItem>
              <a href="https://www.blog.dayaxe.com/how-it-works" target="_blank" rel="noopener noreferrer">How It Works</a>
            </NavigationItem>
            <NavigationItem>
              <Link href="/">
                <a href="https://hotels.dayaxe.com/" target="_blank" rel="noopener noreferrer">For Partners</a>
              </Link>
            </NavigationItem>
          </NavigationList>
        </NavigationContainer>
      </Fragment>
    )
  }
}

export default Navigation;
